<template>
  <div class="shopGroupControlBox">
    <div class="set_s_card">
      <div class="card_title">颜色设置</div>
      <div class="set_item">
        <div>背景颜色</div>
        <div class="content">
          <el-color-picker v-model="controlDefault.bgColor"></el-color-picker>
          <div class="blue-l" @click="returnbgColor">重置</div>
        </div>
      </div>
    </div>

    <div class="set_s_card">
      <div class="card_title">组件设置</div>
      <div class="set_item flex_start">
        <div>展示样式</div>
        <el-radio-group v-model="controlDefault.layout">
          <el-radio :label="0">竖向展示</el-radio>
          <el-radio :label="1">横向滑动</el-radio>
          <el-radio :label="2">推荐展示</el-radio>
        </el-radio-group>
      </div>
      <div class="set_item flex_start">
        <div>商户来源</div>
        <el-radio-group v-model="controlDefault.shopSource">
          <el-radio :label="0">选择商户</el-radio>
          <!-- <el-radio :label="1">选择分类</el-radio> -->
        </el-radio-group>
      </div>
    </div>
    <!-- <div class="radioGroup" v-show="controlDefault.shopSource == 1">
      <p>选择分类</p>
      <el-input disabled v-model="controlDefault.shopClassName" placeholder="请选择商户分类"></el-input>
      <el-button type="primary" @click="chooseClass()">选择</el-button>
    </div> -->
    <!-- 选择商品数量 -->
    <!-- <div class="goodsNum" v-show="controlDefault.shopClassName != '' && controlDefault.shopSource == 1">
      <p>商户数量</p>
      <el-slider :min="0" :max="20" v-model="shopNum" @change="changeNum"></el-slider>
      <span>{{ shopNum }}</span>
    </div> -->
    <!-- 商户显示列表 -->

    <div class="set_i_card" v-show="controlDefault.shopSource == 0">
      <div class="card_top">
        <div class="card_title">商户列表</div>
        <div class="editArea">
          <el-tooltip effect="light" content="添加商户" placement="top-end">
            <img style="margin-right: 8px" @click="addItem" v-show="controlDefault.shopSource == 0" :src="imgH + 'add.png'" alt="" />
          </el-tooltip>
          <el-popover placement="bottom" trigger="click">
            <div class="showImage">
              <div class="image" v-for="(item, index) in controlDefault.list" :key="index">
                <img :src="item.store_logo" alt="" />
                <div class="delMask" @click="deleteItem(index)"><i class="el-icon-delete"></i></div>
              </div>
            </div>
            <img slot="reference" :src="imgH + 'delete.png'" alt="" />
          </el-popover>
        </div>
      </div>
      <vuedraggable
        v-model="controlDefault.list"
        v-bind="{
          animation: 200,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost',
          scroll: true,
        }"
      >
        <transition-group>
          <div class="chooseBtn" v-for="(item, index) in controlDefault.list" :key="index">
            <div class="imageBox">
              <img v-if="item.store_logo" :src="item.store_logo" alt="" />
              <div class="upload" @click="chooseGoods(index)">选择商户</div>
            </div>
            <div class="btnConfig">
              <div>
                <el-input placeholder="商户名称" disabled v-model="item.store_name"></el-input>
              </div>
              <div>
                <el-input placeholder="商户简介" v-model="item.store_intro" disabled></el-input>
              </div>
            </div>
          </div>
        </transition-group>
      </vuedraggable>
    </div>
    <!-- 弹框 -->
    <el-dialog :title="style == 1 ? '选择商户' : '选择分类'" :visible.sync="showShop" width="52%">
      <ListComponents v-if="showShop" :styleMethon="style" @getListItem="getItem"></ListComponents>
    </el-dialog>
  </div>
</template>

<script>
import ListComponents from '@/components/listComponents';
import vuedraggable from 'vuedraggable';
import { imgUrlHead } from '@/util/config.js';
export default {
  props: {
    controlDefault: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ListComponents,
    vuedraggable,
  },
  data() {
    return {
      imgH: imgUrlHead + 'diyComponentsImg/',
      index: -1,
      showShop: false,
      style: 1,
      shopNum: 0,
      storeListTotal: 0,
      storeList: [],
    };
  },
  methods: {
    returnbgColor() {
      this.controlDefault.bgColor = null;
    },
    // 选择商户
    chooseGoods(index) {
      this.index = index;
      this.showShop = true;
    },
    // 删除商户
    deleteItem(index) {
      if (this.controlDefault.list.length <= 1) {
        this.$message.warning('至少添加一个商户!!');
        return;
      }
      this.controlDefault.list.splice(index, 1);
    },
    // 点击新增商户
    addItem() {
      this.controlDefault.list.push({
        store_logo: 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/bgImg.png',
        store_name: '商户名称',
        store_intro: '商户简介',
        goodsList: [
          {
            goods_picture: 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/bgImg.png',
          },
          {
            goods_picture: 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/bgImg.png',
          },
        ],
      });
    },
    // 选择分类
    chooseClass() {
      this.style = 2;
      this.showShop = true;
    },
    // 获取选择门店的数据
    getItem(item) {
      this.showShop = false;
      let action = 'change';
      let that = this;
      // 获取门店商品
      this.$axios
        .post(this.$api.store.goodsList, {
          page: 1,
          rows: 2,
          store_id: item.id,
        })
        .then(res => {
          if (res && res.code == 0) {
            that.$set(item, 'goodsList', res.result.list);
          }
        });
      this.$set(this.controlDefault.list, this.index, item);
    },
    // 更改最大的显示商品数量
    changeNum(newNum) {
      if (newNum > this.controlDefault.list.length) {
        this.shopNum = this.controlDefault.list.length;
        this.$message({
          message: '显示商品数量不可超过该分类最大商品数量',
          type: 'error',
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url(../../../publicStyle.less);
.chooseBtn {
  img {
    border-radius: 0 !important;
  }
  .btnConfig {
    width: 100%;
    & > div {
      width: 100%;
    }
  }
  .el-input {
    margin-right: 0 !important;
  }
}
</style>
